import { NAME } from '#client/public-env';

export const LS_PREFIX = `::zenbusiness::${NAME}::`;

export function createLocalStorageKey(name) {
  return `${LS_PREFIX}${name}`;
}
